import { webnotesClientEnv } from '@nx-frontend/webnotes-client/shared';

export const getStaticFileUrl = (UUID: string, filename: string): string => {
  return `${webnotesClientEnv.staticAssetPrefix}${UUID}/${encodeURIComponent(filename)}`;
};

export const getNoteStaticFileUrl = (workspaceId: string, noteId: string, UUID: string, filename: string): string => {
  return `${webnotesClientEnv.boxServiceUrl}workspaces/${workspaceId}/notes/${noteId}/file/${UUID}/${encodeURIComponent(
    filename
  )}`;
};
